import { gatewayInstances } from "@/arch/@core/main/factory/gateways/GatewayInstances";
import { quizInstances } from "@/arch/new_proposal/quizz/main/factory/QuizzInstances";
export const ContainerInstances = {
  ...gatewayInstances,
  ...quizInstances,
};
